import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let organization_id = useDataValue({
    context: 'patient',
    path: 'person.organization_id',
    viewPath: props.viewPath,
  })

  return {
    variables: { organization_id },
  }
}
